import React, { useEffect, useCallback, useState} from 'react';
import WarpButton from "components/WarpButton.js";
import {connect} from 'react-redux';

const SampleTempo = ({track, tempo}) => { 
    return (
        <div className="sample-tempo">
          <WarpButton track={track}/>
          <div>
            {tempo == null ? '' : 'BPM: ' + tempo }
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SampleTempo);
